import { render, staticRenderFns } from "./Migration.vue?vue&type=template&id=5a1bc9ba&scoped=true"
import script from "./Migration.vue?vue&type=script&lang=js"
export * from "./Migration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1bc9ba",
  null
  
)

export default component.exports